var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const playRight = (_a) => {
    var { color = '#00A3FF', fill = 'none', width = 36, height = 38 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d_13239_54775)" },
            React.createElement("path", { d: "M8 19V14.4053C8 8.70062 11.9094 6.36455 16.6932 9.21688L20.5527 11.5142L24.4122 13.8116C29.1959 16.6639 29.1959 21.3361 24.4122 24.1884L20.5527 26.4858L16.6932 28.7831C11.9094 31.6355 8 29.2994 8 23.5947V19Z", fill: "white" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_13239_54775", x: "0", y: "0", width: "36", height: "38", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { stdDeviation: "4" }),
                React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_13239_54775" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_13239_54775", result: "shape" })))));
};
export default playRight;
